import React, { useEffect, useState } from "react"
import { Container, Row, Col } from "reactstrap"
import { useTranslation } from "react-i18next"
import {
  clearMaintenancePayload,
  getStoredMaintenancePayload,
} from "utils/maintenanceRedirect"

const SystemMaintenance = () => {
  const { t } = useTranslation()
  const [payload] = useState(() => getStoredMaintenancePayload())
  const [secondsLeft, setSecondsLeft] = useState(
    payload?.retryAfterSeconds || 300
  )

  document.title = t("System Maintenance | Portal")

  useEffect(() => {
    if (!payload?.retryAfterSeconds) {
      return undefined;
    }

    setSecondsLeft(payload.retryAfterSeconds)
    const timer = setInterval(() => {
      setSecondsLeft(prev => (prev > 0 ? prev - 1 : 0))
    }, 1000)

    return () => clearInterval(timer)
  }, [payload?.retryAfterSeconds])

  const handleRetry = () => {
    clearMaintenancePayload()
    window.location.href = "/login"
  }

  const minutes = Math.ceil(secondsLeft / 60)

  return (
    <div className="account-pages">
      <Container
        style={{
          display: "flex",
          alignItems: "center",
          height: "100%",
          justifyContent: "center",
        }}
      >
        <Row style={{ justifyContent: "center" }}>
          <Col md={12} lg={10} xl={8}>
            <div className="text-center">
              <div className="mb-4">
                <h1 className="display-1 fw-bold text-warning">503</h1>
                <h4 className="text-uppercase">{t("System Under Maintenance")}</h4>
                <div className="mt-3">
                  <i className="mdi mdi-wrench display-4 text-warning"></i>
                </div>
              </div>

              <div className="mt-4">
                <p className="text-muted mb-3">
                  {payload?.message ||
                    t(
                      "System is under maintenance. Please try again later."
                    )}
                </p>
                {secondsLeft > 0 && (
                  <p className="text-muted mb-4">
                    {t("You can retry in approximately {{minutes}} minute(s).", {
                      minutes,
                    })}
                  </p>
                )}

                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleRetry}
                  disabled={secondsLeft > 0}
                >
                  <i className="mdi mdi-refresh me-1"></i> {t("Try Again")}
                </button>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default SystemMaintenance
